
import { Component, Vue, Prop } from 'vue-property-decorator';
import { permissions, VShow } from '@/router/vids';

import TemplateRepair from '../template/TemplateRepair.vue'
import TemplateOrder from '../template/TemplateOrder.vue'
import TemplateDiyPamras from '../template/SettingTemplateDiyPamras.vue'
import TemplateAddress from '../template/TemplateAddress.vue'
import TemplatePhenomenon from '../template/TemplatePhenomenon.vue'
import PhenomenonGroups from '../template/PhenomenonGroups.vue'
import TemplateFault from '../template/TemplateFault.vue'
import TemplateTags from '../template/TemplateTags.vue'
import TemplateTroubleDescribleTags from '../template/TemplateTroubleDescribleTags.vue'
import TemplateAddedProgress from '../template/TemplateAddedProgress.vue'
import TemplateVariousTags from '../template/TemplateVariousTags.vue'
import TemplateRemark from '../template/TemplateRemark.vue'
import TemplateImage from '../template/TemplateImage.vue'
import TemplateEvaluateTags from '../template/TemplateEvaluateTags.vue';
import TemplateEvaluateCustom from '../template/TemplateEvaluateCustom.vue';
import TemplateQuestionnaire from '../template/TemplateQuestionnaire.vue'
import TemplateQuestionBank from '../template/TemplateQuestionBank.vue'
import TemplatePrice from '../template/TemplatePrice.vue'
import TemplateWorkTime from '../template/TemplateWorkTime.vue'

@Component({
  name: 'SystemSettingTemplateList',
  components: {
    TemplateRepair,
    TemplateOrder,
    TemplateDiyPamras,
    TemplateAddress,
    TemplatePhenomenon,
    PhenomenonGroups,
    TemplateFault,
    TemplateTags,
    TemplateTroubleDescribleTags,
    TemplateAddedProgress,
    TemplateVariousTags,
    TemplateRemark,
    TemplateImage,
    TemplateEvaluateTags,
    TemplateEvaluateCustom,
    TemplateQuestionnaire,
    TemplateQuestionBank,
    TemplatePrice,
    TemplateWorkTime
  }
})
export default class extends Vue {
  private windowHg = window.innerHeight - 140;
  private activeName:any = 'template'
  private questionCreate: any = '1'
  private activeNameQuestion = 'question'

  private permissions=permissions;
  private tabBefore(activeName: any) {
    if (activeName === 'empty-1' || activeName === 'empty-2' || activeName === 'empty-3' || activeName === 'empty-4') {
      return false;
    }
  }
  created() {
    if (this.$route.query && this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName
    } else {
      this.activeName = 'template'
    }
  }
  private VShowPermissions(Permissions:any) {
    return VShow({ Permissions: Permissions })
  }
  // private toggleQuestionHandle(val:boolean) {
  //   this.isShow = val
  // }
  // private toggleQuestionBank(val: any) {
  // this.isShow = true
  // this.questionCreate = val
  // }
  private toggleQuestionBankClick(val: any) {
    // if (val.name === 'question') {
    //   this.questionCreate = '1'
    // } else {
    //   this.questionCreate = '2'
    // }
  }
}
